import { ModelViewer } from '../lib/ModelViewer';
import { BallsGLTF } from '../models/BallsGLTF';
import { GMachine01_01_GLTF } from '../models/GMachine01_01_GLTF';
import { GMachine01_02_GLTF } from '../models/GMachine01_02_GLTF';
import { Machine01_01_GLTF } from '../models/Machine01_01_GLTF';
import { Machine01_02_GLTF } from '../models/Machine01_02_GLTF';
import { Machine01_05_GLTF } from '../models/Machine01_05_GLTF';
import { Machine02_01_01_GLTF } from '../models/Machine02_01_01_GLTF';
import { Machine02_05_02_GLTF } from '../models/Machine02_05_02_GLTF';
import { Machine03_01_01_01_GLTF } from '../models/Machine03_01_01_01_GLTF';
import { Machine04_01_01_01_01_GLTF } from '../models/Machine04_01_01_01_01_GLTF';
import { Machine05_01_01_01_01_01_GLTF } from '../models/Machine05_01_01_01_01_01_GLTF';
import { Machine07_01_01_01_01_01_01_01_GLTF } from '../models/Machine07_01_01_01_01_01_01_01_GLTF';

export function loadAssetsByMachine(machine: string, viewer: ModelViewer, result: number[]): void {
    const pathToAssets = viewer.getPathToAssets();
    switch (machine) {
        case 'machine01_01':
            Machine01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#008cff',
                    balls: `${pathToAssets}/models/machine01_balls_150.glb`,
                    positions: 1,
                    suffix: '',
                    result,
                },
            ]);
            break;
        case 'machine01_01_balls2':
            Machine01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine01_balls2_100.glb`,
                    positions: 1,
                    suffix: '001',
                    result,
                },
            ]);
            break;
        case 'machine01_02':
            Machine01_02_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine01_balls_150.glb`,
                    positions: 2,
                    suffix: '',
                    result,
                },
            ]);
            break;
        case 'machine01_05':
            Machine01_05_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.whiteBlack,
                    color: '#ffffff',
                    balls: `${pathToAssets}/models/machine01_05_balls_90.glb`,
                    positions: 5,
                    suffix: '003',
                    result,
                },
            ]);
            break;
        case 'machine02_05_02':
            Machine02_05_02_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.whiteBlack,
                    color: '#ffffff',
                    balls: `${pathToAssets}/models/machine02_05_02_balls_50_left.glb`,
                    positions: 5,
                    suffix: '002',
                    result: [result[0], result[1], result[2], result[3], result[4]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff0000',
                    balls: `${pathToAssets}/models/machine02_05_02_balls_12_right.glb`,
                    positions: 2,
                    suffix: '001',
                    result: [result[5], result[6]],
                },
            ]);
            break;
        case 'machine02_01_01':
            Machine02_01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine02_01_01_balls_0-9_left.glb`,
                    positions: 1,
                    suffix: '002',
                    result: [result[0]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine02_01_01_balls_0-9_right.glb`,
                    positions: 1,
                    suffix: '003',
                    result: [result[1]],
                },
            ]);
            break;
        case 'machine03_01_01_01':
            Machine03_01_01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine03_01_01_01_balls_0-9_01.glb`,
                    positions: 1,
                    suffix: '',
                    result: [result[0]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine03_01_01_01_balls_0-9_02.glb`,
                    positions: 1,
                    suffix: '002',
                    result: [result[1]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine03_01_01_01_balls_0-9_03.glb`,
                    positions: 1,
                    suffix: '003',
                    result: [result[2]],
                },
            ]);
            break;
        case 'machine04_01_01_01_01':
            Machine04_01_01_01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine04_01_01_01_01_balls_0-9_01.glb`,
                    positions: 1,
                    suffix: '',
                    result: [result[0]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine04_01_01_01_01_balls_0-9_02.glb`,
                    positions: 1,
                    suffix: '001',
                    result: [result[1]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine04_01_01_01_01_balls_0-9_03.glb`,
                    positions: 1,
                    suffix: '002',
                    result: [result[2]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine04_01_01_01_01_balls_0-9_04.glb`,
                    positions: 1,
                    suffix: '003',
                    result: [result[3]],
                },
            ]);
            break;
        case 'machine05_01_01_01_01_01':
            Machine05_01_01_01_01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine05_01_01_01_01_01_balls_0-9_01.glb`,
                    positions: 1,
                    suffix: '',
                    result: [result[0]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine05_01_01_01_01_01_balls_0-9_02.glb`,
                    positions: 1,
                    suffix: '001',
                    result: [result[1]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine05_01_01_01_01_01_balls_0-9_03.glb`,
                    positions: 1,
                    suffix: '002',
                    result: [result[2]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine05_01_01_01_01_01_balls_0-9_04.glb`,
                    positions: 1,
                    suffix: '003',
                    result: [result[3]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine05_01_01_01_01_01_balls_0-9_05.glb`,
                    positions: 1,
                    suffix: '004',
                    result: [result[4]],
                },
            ]);
            break;
        case 'machine07_01_01_01_01_01_01_01':
            Machine07_01_01_01_01_01_01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_01.glb`,
                    positions: 1,
                    suffix: '',
                    result: [result[0]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_02.glb`,
                    positions: 1,
                    suffix: '001',
                    result: [result[1]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_03.glb`,
                    positions: 1,
                    suffix: '002',
                    result: [result[2]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_04.glb`,
                    positions: 1,
                    suffix: '003',
                    result: [result[3]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_05.glb`,
                    positions: 1,
                    suffix: '004',
                    result: [result[4]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_06.glb`,
                    positions: 1,
                    suffix: '005',
                    result: [result[5]],
                },
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/machine07_01_01_01_01_01_01_01_balls_0-9_07.glb`,
                    positions: 1,
                    suffix: '006',
                    result: [result[6]],
                },
            ]);
            break;
        case 'gMachine01_01':
            GMachine01_01_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/gMachine01_01_balls_200.glb`,
                    positions: 12,
                    suffix: '',
                    result,
                },
            ]);
            break;
        case 'gMachine01_02':
            GMachine01_02_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/gMachine01_02_balls_70.glb`,
                    positions: 20,
                    suffix: '002',
                    result,
                    maxPerRow: 10,
                },
            ]);
            break;
        case 'gMachine01_02_80':
            GMachine01_02_GLTF.loadAssets(viewer, [
                {
                    texture: BallsGLTF.blackWhite,
                    color: '#ff9100',
                    balls: `${pathToAssets}/models/gMachine01_02_balls_80.glb`,
                    positions: 20,
                    suffix: '003',
                    result,
                    maxPerRow: 10,
                },
            ]);
            break;
        default:
    }
}

export function loadModelByMachine(machine: string, viewer: ModelViewer): void {
    switch (machine) {
        case 'machine01_01':
            Machine01_01_GLTF.loadModel(viewer);
            break;
        case 'machine01_01_balls2':
            Machine01_01_GLTF.loadModel(viewer);
            break;
        case 'machine01_02':
            Machine01_02_GLTF.loadModel(viewer);
            break;
        case 'machine01_05':
            Machine01_05_GLTF.loadModel(viewer);
            break;
        case 'machine02_05_02':
            Machine02_05_02_GLTF.loadModel(viewer);
            break;
        case 'machine02_01_01':
            Machine02_01_01_GLTF.loadModel(viewer);
            break;
        case 'machine03_01_01_01':
            Machine03_01_01_01_GLTF.loadModel(viewer);
            break;
        case 'machine04_01_01_01_01':
            Machine04_01_01_01_01_GLTF.loadModel(viewer);
            break;
        case 'machine05_01_01_01_01_01':
            Machine05_01_01_01_01_01_GLTF.loadModel(viewer);
            break;
        case 'machine07_01_01_01_01_01_01_01':
            Machine07_01_01_01_01_01_01_01_GLTF.loadModel(viewer);
            break;
        case 'gMachine01_01':
            GMachine01_01_GLTF.loadModel(viewer);
            break;
        case 'gMachine01_02':
            GMachine01_02_GLTF.loadModel(viewer);
            break;
        case 'gMachine01_02_80':
            GMachine01_02_GLTF.loadModel(viewer);
            break;
        default:
    }
}
